import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  width: "35",
  height: "40",
  viewBox: "0 0 35 40",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      d: "M27.7386 0C26.8772 0 26.5036 0.542825 26.1941 1.09874C26.1941 1.09874 13.7659 23.1388 13.3569 23.8626C13.3778 23.9019 21.554 38.9013 21.554 38.9013C21.8398 39.4126 22.2817 40 23.1654 40H28.9279C29.2753 40 29.5467 39.8689 29.6935 39.6316C29.8469 39.3851 29.843 39.0599 29.6818 38.74L21.5488 23.8809C21.5409 23.8691 21.5409 23.8547 21.5488 23.8429L34.3218 1.2587C34.4818 0.940094 34.4857 0.614928 34.3336 0.368436C34.1868 0.131121 33.9141 0 33.5666 0H27.7386Z",
      fill: "#026466"
    }, null, -1),
    _createElementVNode("path", {
      d: "M2.73993 8.25358C2.88678 8.01495 3.17917 7.89302 3.52662 7.89302H9.29559C10.1806 7.89302 10.6146 8.46336 10.9017 8.9747C10.9017 8.9747 14.8443 15.8529 14.8679 15.8909C14.6345 16.3026 8.64003 26.9044 8.64003 26.9044C8.34503 27.4367 7.92939 28.0189 7.06667 28.0189H1.2977C0.950246 28.0189 0.690638 27.8629 0.543792 27.6255C0.3917 27.379 0.383834 27.0591 0.543792 26.7405L6.67333 15.9237C6.67988 15.9119 6.67988 15.904 6.67333 15.8909L2.77271 9.13859C2.61144 8.81737 2.58784 8.50007 2.73993 8.25358Z",
      fill: "#026466"
    }, null, -1)
  ])))
}
export default { render: render }